import {useSelector, useDispatch} from 'react-redux'
import Title from '../helmet'
import {Navigate} from 'react-router-dom'
import {LOGIN, DASHBOARD} from '../routes'
import {Suspense, useEffect} from 'react'
import MasterLayout from 'layout/MasterLayout'
import {LayoutSplashScreen} from 'layout/core'
import {getMe} from 'services/api/actions'
import {parseError} from 'utils'
import {updateUser} from 'store/actions/auth'
import {is_societyAdmin, is_superAdmin, is_technician , is_vendor } from 'helpers/userRoles'
import {PERMISSION_ROLES} from 'constants'
import {has_screenPermission} from 'helpers/userPermissions'

export default function PrivateRoute(props) { 
  const Component = props.component
  const route = props.route
  const permissions = props.permission
  const screen_id = props.screen_id
  const {superAdmin, societyAdmin, technicians ,vendor } = PERMISSION_ROLES

  const {auth} = useSelector((state) => state)
  const dispatch = useDispatch()

  const hasSession = auth.token && auth.user

  const hasRolePermission = () =>
    permissions === null ||
    permissions.length === 0 ||
    permissions.length === Object.keys(PERMISSION_ROLES).length ||
    (permissions.includes(superAdmin) && is_superAdmin(auth.user)) ||
    (permissions.includes(societyAdmin) && is_societyAdmin(auth.user)) ||
    (permissions.includes(technicians) && is_technician(auth.user)) ||
    (permissions.includes(vendor) && is_vendor(auth.user)) 

  const hasScreenPermission = () =>
    screen_id ? has_screenPermission(auth.permissions_enum, screen_id, auth.user) : true

  const hasPermission = () => hasRolePermission() && hasScreenPermission()

  const getProfileDetails = () => {
    getMe()
      .then((response) => {
        dispatch(updateUser(response.data ?? null))
      })
      .catch((error) => {
        console.log(parseError(error))
      })
  }

  useEffect(() => {
    if (auth.token) getProfileDetails()
  }, [])

  return (
    <>
      {hasSession ? (
        <>
          {hasPermission() ? (
            <>
              <Title title={props.title} />
              <MasterLayout>
                <Suspense fallback={<LayoutSplashScreen />}>
                  <Component route={route} />
                </Suspense>
              </MasterLayout>
            </>
          ) : (
            <Navigate to={DASHBOARD} replace={true} />
          )}
        </>
      ) : (
        <Navigate to={LOGIN} replace={true} />
      )}
    </>
  )
}
